import React from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory, Link } from 'react-router';
import * as FacilitiesActions from '../../actions/facilities_actions';
import * as UserActions from '../../actions/user_actions';
import * as SettingScreen from '../../actions/settingScreen_actions';
import { bindActionCreators } from 'redux';
import { RestPwdDialog } from '../reset_pwd_dialog';
import { ModalDialogCommon } from '../modal_dialog_common';
import Header from '../../components/header';
import { validate } from '../../validations';
import InputMask from 'react-input-mask';
let screenIdentifier = 'facilities_admin_edit';

export var EditFacilitiesAdmin = React.createClass({
    getInitialState() {
        return {
            resetpwd: false,
            resetpwdClicked: false,
            okModalMessage: null,
            resetPasswordResponseError: null,
            isSubmitEnabled: null,
            isEditMode: null,
            errorMessage: null,
            isProfileUpdateSucceed: null,
        }
    },
    componentWillMount() {
        //  this.props.User.ChangePassword = {};
        //this.props.ProfileUpdate = {}
    },
    componentWillReceiveProps(nextProps) {

        // if (nextProps.Setting.Changepassword ? nextProps.Setting.Changepassword.status == 200 : false) {
        //     this.setState({ 'resetpwd': false });
        // }
        //reset password
        if (this.state.resetpwdClicked) {
            this.setState({ resetpwdClicked: false });
            if (nextProps.Setting.Changepassword && nextProps.Setting.Changepassword.status === 200) {
                this.setState({ resetpwd: false, okModalMessage: nextProps.Setting.Changepassword.message });
            }
            else {
                this.setState({ resetPasswordResponseError: nextProps.Setting.Changepassword.message });
            }
        }

        // update Admin details
        if (this.state.isSubmitEnabled) {
            this.setState({ isSubmitEnabled: null });
            if (nextProps.Setting ? nextProps.Setting.profileUpdate.status == 200 : false) {
                this.setState({ isEditMode: null });
                this.setState({ okModalMessage: nextProps.Setting.profileUpdate.message });
                this.setState({ isProfileUpdateSucceed: true });
            }
            else {
                this.setState({ okModalMessage: nextProps.Setting.profileUpdate.message });
                this.setState({ isProfileUpdateSucceed: null });
            }
        }
    },
    componentDidMount() {

    },
    getAdminDetail() {
        var details = this.props.FacilitiesDetails.FaciliteAdminUser.data;
        return details;
    },
    remove_error(event) {
        event.target.className = 'inputText';
    },
    phon_validate(event) {
        let mobile = event.target.value;
        let isMobileTrue = validate.phone(mobile);
        isMobileTrue ? event.target.className = 'inputText' : event.target.className = 'inputText error';

    },
    removeResetPasswordResponseError() {
        this.setState({ resetPasswordResponseError: null });
    },
    editFacility() {
        // To make the fields editable
        if (!this.state.isEditMode) {
            this.setState({ isEditMode: true });
            return;
        }
        if (this.state.isEditMode && !this.state.isSubmitEnabled) {
            this.setState({ okModalMessage: "Please update any field to save." });
            return;
        }
        this.setState({ errorMessage: null });
        var firstName = this.refs.firstName.value.trim(),
            lastName = this.refs.lastName.value.trim(),
            mobile = this.refs.mobile.state.value.replace(/ /g, ""),
            facilityRoleId = this.refs.designation.value.trim(),
            facility_id = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        let isPhoneTrue = validate.phone(mobile);
        !firstName.length ? this.refs.firstName.className = "inputText error" : this.refs.firstName.className = "inputText";
        !lastName.length ? this.refs.lastName.className = "inputText error" : this.refs.lastName.className = "inputText";
        !isPhoneTrue ? this.setState({ mobileCssClass: "inputText error" }) : this.setState({ mobileCssClass: "inputText" });

        if (firstName.length && lastName.length && mobile.length && isPhoneTrue) {
            var data = {
                "id": this.props.FacilitiesDetails.FaciliteAdminUser.data.id,        //admin_user_id mandatory
                "uniqueKey": this.props.FacilitiesDetails.FaciliteAdminUser.data.uniqueKey, //mandatory
                "firstName": firstName,
                "lastName": lastName,
                "mobile": mobile,
                "facilityRole": { "id": facilityRoleId },
               "facility": { "id": facility_id },
                "role": { "id": this.props.FacilitiesDetails.FaciliteAdminUser.data.facilities[0].role.id }    //  admin_user_role_id  mandatory for patient profile update
            }
            this.props.Dispatch(SettingScreen.profileUpdate(data))
        }
        else {
            this.setState({ errorMessage: "Please enter necessary fields to proceed." });
        }
    },
    cancel() { this.props.router.goBack(); },
    resetPwdModal() { this.setState({ 'resetpwd': true }) },
    resetPassword(obj) {

        var data = {};
        var new_pwd = obj.refs.new_pwd.value.trim();
        var password = obj.refs.re_pwd.value.trim();
        if (new_pwd != password) {
            return false;
        }

        data.id = this.props.FacilitiesDetails.FaciliteAdminUser.data.id;
        data.uniqueKey = this.props.FacilitiesDetails.FaciliteAdminUser.data.uniqueKey;
        data.password = password;
        data.isPasswordChange = obj.refs.isPasswordChange.checked;
        this.props.Dispatch(SettingScreen.changePassword(data));
        this.setState({ resetpwdClicked: true });

    },
    closebox() {
        this.setState({ okModalMessage: null, isActivation: false, resetpwd: false, resetPasswordResponseError: null });
        if (this.state.isProfileUpdateSucceed) {
            this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(this.props.FacilitiesDetails.FaciliteDetailsByID.data.id));
        }

    },
    enableSubmit() {
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },
    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },
    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },
    render() {
        var _facilityDetails = this.getAdminDetail();
        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} breadcrumb={true}/>
                <div className="breadcrumb-custom">
                  <h2> <Link  to='/facilities'>CLINICS</Link> >  <a  onClick={this.props.router.goBack}>{_facilityDetails.facilities[0].facility.name}</a> > {_facilityDetails.firstName + " - EDIT"} </h2>
                </div>
                <div className="row">
                    <div className="col-xs-12 reset-password pull-right">
                        <button className="gray-button pull-right" onClick={this.resetPwdModal}>RESET PASSWORD</button>
                    </div>
                </div>
                <div className="white-box">
                    <div className="edit-facility">
                        <h4>EDIT MOBI ADMIN </h4>
                        <div className="row">
                            <div className="col-xs-6 no-padding facility-details">
                                <div className="input-group">
                                    <input type="text" className="inputText" ref="firstName" required onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} defaultValue={_facilityDetails.firstName} />
                                    <span className="floating-label">FIRST NAME</span>
                                </div>
                                <div className="input-group readonly">
                                    <input type="text" tabIndex="-1" className="inputText" ref="email" required defaultValue={_facilityDetails.email} />
                                    <span className="floating-label">EMAIL</span>
                                </div>
                                {/* <div className="input-group">
                                    <input type="text" tabIndex="-1" className="inputText" ref="designation" required defaultValue={_facilityDetails && _facilityDetails.facilities[0].facilityRole.name} />
                                    <span className="floating-label"> DESIGNATION</span>
                                </div> */}                                
                                <div className="col-xs-12 no-padding">
                                        <div className="aj-dropdown with-label">
                                            <label>Professional Role</label>
                                            <div className="source">
                                                <div className="question-selection">
                                                    <select ref="designation" onChange={this.selectionChanged} onFocus={this.selectionChanged} 
                                                    onBlur={this.selectionChanged} defaultValue={_facilityDetails && _facilityDetails.facilities[0].facilityRole?_facilityDetails.facilities[0].facilityRole.id:''}required>
                                                        {/* <option value="" default>Designation</option>
                                                        <option value="3" >Psychiatrist Support Staff</option>
                                                        <option value="4" >Therapist</option>
                                                        <option value="6" >Administrative Staff</option> */}
                                                        <option value="" default> Professional Role </option>
                                                        {/* <option value="3" >Psychiatrist Support Staff</option>
                                                            <option value="4" >Therapist</option> */}
                                                        {/* <option value="6" >Administrative Staff</option> */}
                                                        <option value="9" >Clinician/Therapist</option>
                                                        <option value="10" >Prescriber/Psychiatrist/Other Medical Personnel</option>
                                                        <option value="11" >Clinical Supervisor/Team Lead</option>
                                                        <option value="12" >Clinic Coordinator</option>
                                                        <option value="13" >Administrative Support Staff</option>
                                                        <option value="14" >Family Advocate</option>
                                                        <option value="15" >Peer Support Specialist</option>
                                                        <option value="16" >Case Manager/Recovery Coach</option>
                                                        <option value="17" >Supported Education & Employment Specialist</option>
                                                        <option value="18" >Program Director</option>
                                                        <option value="19" >Research Staff/Site Coordinator</option>
                                                        <option value="20" >Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <div className="col-xs-6 no-padding facility-details">
                                <div className="input-group">
                                    <input type="text" className="inputText" required ref="lastName" onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} defaultValue={_facilityDetails.lastName} />
                                    <span className="floating-label">LAST NAME</span>
                                </div>
                                <div className="input-group">
                                    <InputMask type="text" className="inputText" onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.phon_validate} defaultValue={_facilityDetails.mobile} ref="mobile" mask="999 999 9999" maskChar={null}></InputMask>
                                    <span className="floating-label">PHONE</span>
                                </div>
                                <div className="input-group readonly">
                                    <input type="text" tabIndex="-1" className="inputText" required onFocus={this.remove_error} defaultValue={_facilityDetails ? _facilityDetails.facilities[0].facility.name : ""} />
                                    <span className="floating-label">Clinic</span>
                                </div>
                            </div>
                        </div>
                        {this.state.errorMessage && <div className="error-message">
                            <span className="red-color">{this.state.errorMessage} </span>
                        </div>}

                        <button className="gray-button" onClick={this.editFacility}>{this.state.isEditMode ? "SAVE" : "EDIT"}</button>
                        <button className="white-button" onClick={this.cancel}>BACK</button>
                    </div>
                </div>
                <div> {this.state.okModalMessage && <ModalDialogCommon message={this.state.okModalMessage} action={this.closebox} />}</div>
                <div>  {this.state.resetpwd ? <RestPwdDialog confirm={this.resetPassword} cancel={this.closebox} errorMessage={this.state.resetPasswordResponseError} removeErrorMessage={this.removeResetPasswordResponseError} /> : ''}  </div>
            </div>
        );
    }
});


let mapStateToProps = (state) => {

    return {
        FacilitiesDetails: state.Facilites,
        LogingDetails: state.User.loginData,
        User: state.User,
        Setting: state.Setting,
        ProfileUpdate: state.User.ProfileUpdate
    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(EditFacilitiesAdmin));



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/edit-facility-admin.js
 **/